import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppContainer from '../containers/AppContainer';

const AppRouter = () => (
  <Router>
    <AppContainer />
  </Router>
);

export default AppRouter;
